import axios from 'axios';
import Cookies from 'js-cookie';
import { getOnboardingContext } from './onboarding';

const base = () => process.env.NEXT_PUBLIC_BASE_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${Cookies.get('token')}` } });
export async function inspectRepInvitation(token) {
  const { data } = await axios.get(`${base()}/rep-invitations/inspect`, { params: { token } });
  return data.data;
}
export async function acceptRepInvitation(inviteId, token) {
  const { data } = await axios.post(`${base()}/rep-invitations/${inviteId}/accept`, { token }, auth());
  return data.data;
}
export async function getRepOnboardingContext() {
  const { data } = await axios.get(`${base()}/reps/onboarding/context`, auth());
  return data.data;
}
export async function completeRepOnboarding(body) {
  const { data } = await axios.post(`${base()}/reps/onboarding/complete`, body, auth());
  return data.data;
}
export async function repPostLoginDestination() {
  const context = await getOnboardingContext();
  return context.nextPath || '/onboarding';
}
